var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPentagon16(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.96658 12.6667H11.0333L13.0833 6.51666L7.99992 2.96666L2.91659 6.51666L4.96658 12.6667ZM4.96658 14C4.6777 14 4.41659 13.9167 4.18325 13.75C3.94992 13.5833 3.78881 13.3611 3.69992 13.0833L1.64992 6.95C1.56103 6.66111 1.56103 6.37778 1.64992 6.1C1.73881 5.82222 1.90547 5.6 2.14992 5.43333L7.23325 1.86666C7.46659 1.71111 7.72214 1.63333 7.99992 1.63333C8.2777 1.63333 8.53325 1.71111 8.76658 1.86666L13.8499 5.43333C14.0944 5.6 14.261 5.82222 14.3499 6.1C14.4388 6.37778 14.4388 6.66111 14.3499 6.95L12.2999 13.0833C12.211 13.3611 12.0499 13.5833 11.8166 13.75C11.5833 13.9167 11.3221 14 11.0333 14H4.96658Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPentagon16);
export default __webpack_public_path__ + "static/media/Pentagon16.aa022ab32e403578cff9dac7bf5736a8.svg";
export { ForwardRef as ReactComponent };